import React, { Component } from 'react'
import { connect } from 'react-redux'

// Utils
import { translation } from '../../../utils/helpers'

// Actions
import { saveCarOwnerPortalInformation, getCarOwnerPortalInformation } from '../../../actions/settings'

// Elements
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import TextArea from '../../../shared/elements/textarea'
// import Divider from '../../../shared/elements/divider'

import './carownerportal.scss'

class CarOwnerPortal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      carOwnerPortalPortal: {
        CarOwnerPortalEnabled: false,
        CarOwnerPortalPrivacyPolicyUrl: '',
        CarOwnerPortalWelcomeMessageText: ''
      }
    }
    this.getCarOwnerPortalInformation = this.getCarOwnerPortalInformation.bind(this)
    this.saveCarOwnerPortalInformation = this.saveCarOwnerPortalInformation.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getCarOwnerPortalInformation()
  }

  getCarOwnerPortalInformation () {
    this.props.getCarOwnerPortalInformation().then((res) => {
      console.log(res.data)
      this.setState({
        carOwnerPortalPortal: res.data
      })
    }, () => {
      // Err loading
    })
  }

  saveCarOwnerPortalInformation () {
    this.props.saveCarOwnerPortalInformation(this.state.carOwnerPortalPortal).then((res) => {
      this.setState({
        carOwnerPortalPortal: res.data
      })
      // window.toastr.success(translation('18156'), translation('13424'))
    }, () => {
      // Err saving
      window.toastr.error(translation('18157'), translation('216'))
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'checkbox') {
      value = e.target.checked
      if (value) {
        // recheck permissions Allow show or hide menu client notification
        $(this.props.auth.permissions.CarOwnerPortalEnabled ? '.show-menu-notification' : '.hide-menu-notification').css('display', 'block')
      } else {
        $(this.props.auth.permissions.CarOwnerPortalEnabled ? '.show-menu-notification' : '.hide-menu-notification').css('display', 'none')
      }
    }
    this.setState({
      carOwnerPortalPortal: {
        ...this.state.carOwnerPortalPortal,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    this.saveCarOwnerPortalInformation()
  }

  renderWelcomeMessageText () {
    return (
      <Col span={5}>
        <Panel title={18153}>
          <div className='submit-text'>
            <TextArea placeholder={translation(18153)} name='CarOwnerPortalWelcomeMessageText' labelText={translation(18154)} value={this.state.carOwnerPortalPortal.CarOwnerPortalWelcomeMessageText || ''} onChange={this.onChange} onBlur={this.onBlur} />
          </div>
        </Panel>
      </Col>
    )
  }

  renderPrivacyPolicyInfo () {
    return (
      <Col span={5}>
        <Panel title={16653}>
          <Text name='CarOwnerPortalPrivacyPolicyUrl' labelText={translation(16740)} value={this.state.carOwnerPortalPortal.CarOwnerPortalPrivacyPolicyUrl || ''} placeholder={'http://'} onChange={this.onChange} onBlur={this.onBlur} />
        </Panel>
      </Col>

    )
  }

  render () {
    return (
      <div className='bookingportal__settings'>
        <Row>
          <div className='clearfix colwrapper'>
            <Col>
              <Panel title={18152}>
                <Switch name='CarOwnerPortalEnabled' onChange={this.onChange} checked={this.state.carOwnerPortalPortal.CarOwnerPortalEnabled} labelText={18155} />
              </Panel>
            </Col>
          </div>
        </Row>
        <Row>
          {this.state.carOwnerPortalPortal.CarOwnerPortalEnabled && this.renderWelcomeMessageText()}
          {this.state.carOwnerPortalPortal.CarOwnerPortalEnabled && this.renderPrivacyPolicyInfo()}
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  saveCarOwnerPortalInformation,
  getCarOwnerPortalInformation
})(CarOwnerPortal)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/CarOwnerPortal/index.js